import * as m from "./../../dist/es2015/stock.js";
export const am5stock = m;